import Link from 'next/link';
import React from 'react';
import { TbIdOff } from 'react-icons/tb/';
import Button, { ButtonSize, ButtonType } from '@/components/UI/buttons/Button';

export const EmptyBidCard = ({
  title,
  hasButton = false,
  buttonPath = '/deals',
  buttonText = 'View Opportunities',
}: {
  title: string | undefined;
  hasButton?: boolean;
  buttonPath?: string;
  buttonText?: string;
}) => {
  return (
    <div className="flex w-full flex-col place-content-center place-items-center py-8 text-black">
      <TbIdOff className="text-heading-3" />
      <div className="w-1/2 justify-center p-4 text-center font-gt-haptik text-heading-6-mobile  md:text-heading-6">
        {title}
      </div>
      {hasButton ? (
        <Link className="flex items-center py-2" href={buttonPath}>
          <Button size={ButtonSize.primary} type={ButtonType.primary}>
            {buttonText}
          </Button>
        </Link>
      ) : null}
    </div>
  );
};
